import React, { useState, useRef, useEffect, useCallback } from "react";
import { useSpring, animated } from "react-spring";
import { Background, ModalContent, CloseModalButton, Form, FormContent, Button, Input } from "../../ModalEditStyle";
import api from "../../../../services/api";
import Swal from "sweetalert2";

export default function ModalEdit({ showModal, setShowModal, data, recarregaTabela }) {
  const modalRef = useRef();
  const [formData, setFormData] = useState({
    matricula: "",
    nome_colaborador: "",
    email: "",
    data_nascimento: "",
    cesta_natal: false,
    brinquedo_1: "",
    brinquedo_2: "",
    brinquedo_3: "",
    brinquedo_4: "",
    brinquedo_5: "",
    limpaData: false,
  });
  const animation = useSpring({
    config: {
      duration: 150,
    },
    opacity: showModal ? 1 : 0,
    transform: showModal ? `translateY(0%)` : `translateY(-100%)`,
  });

  const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 1000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  const keyPress = useCallback(
    (e) => {
      if (e.key === "Escape" && showModal) setShowModal(!showModal);
    },
    [setShowModal, showModal]
  );

  useEffect(() => {
    document.addEventListener("keydown", keyPress);
    return () => document.removeEventListener("keydown", keyPress);
  }, [keyPress]);

  useEffect(() => {
    if (data) {
      setFormData({
        matricula: data.matricula || "",
        nome_colaborador: data.nome || "",
        email: data.email || "",
        data_nascimento: data.data_nascimento ? String(data.data_nascimento).slice(0, 10) : "",
        cesta_natal: !!data.cesta_natal,
        brinquedo_1: data.brinquedo_1 || "",
        brinquedo_2: data.brinquedo_2 || "",
        brinquedo_3: data.brinquedo_3 || "",
        brinquedo_4: data.brinquedo_4 || "",
        brinquedo_5: data.brinquedo_5 || "",
        limpaData: false,
      });
    }
  }, [data]);

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  async function handleSubmit(e) {
    e.preventDefault();

    const dataEnviar = {
      matricula: formData.matricula,
      nome_colaborador: formData.nome_colaborador,
      email: formData.email,
      data_nascimento: formData.data_nascimento || null,
      cesta_natal: formData.cesta_natal ? 1 : 0,
      brinquedo_1: formData.brinquedo_1,
      brinquedo_2: formData.brinquedo_2,
      brinquedo_3: formData.brinquedo_3,
      brinquedo_4: formData.brinquedo_4,
      brinquedo_5: formData.brinquedo_5,
      limpaData: formData.limpaData,
    };

    try {
      const response = await api.put(`/rh/controle-cestas/atualizar-dados`, { data: dataEnviar });

      if (response.data.error) {
        return Swal.fire("Atenção!", response.data.error, "warning");
      }

      Toast.fire({
        icon: "success",
        title: "Editado com sucesso!",
      });

      setShowModal(!showModal);

      if (recarregaTabela) {
        recarregaTabela();
      }
    } catch (error) {
      Swal.fire("Atenção!", error.response?.data?.error || "Erro ao atualizar!", "error");
    }
  }

  return (
    <>
      {showModal ? (
        <Background
          ref={modalRef}
          onClick={(e) => {
            if (modalRef.current === e.target) {
              setShowModal(!showModal);
            }
          }}
        >
          <animated.div style={animation}>
            <ModalContent>
              <br />
              <Form onSubmit={handleSubmit}>
                <h3>Editar Controle de Cestas</h3>
                <FormContent>
                  <Input type="text" value={formData.matricula} placeholder="Matrícula" disabled />
                  <Input
                    type="text"
                    value={formData.nome_colaborador}
                    onChange={(e) => handleChange("nome_colaborador", e.target.value)}
                    placeholder="Nome do colaborador"
                  />
                  <Input
                    type="email"
                    value={formData.email}
                    onChange={(e) => handleChange("email", e.target.value)}
                    placeholder="Digite o email"
                  />
                  <Input
                    type="date"
                    value={formData.data_nascimento}
                    onChange={(e) => handleChange("data_nascimento", e.target.value)}
                    placeholder="Data de nascimento"
                  />

                  <label style={{ marginBottom: 12 }}>
                    <input
                      type="checkbox"
                      checked={formData.cesta_natal}
                      onChange={(e) => handleChange("cesta_natal", e.target.checked)}
                      style={{ marginRight: 6 }}
                    />
                    Possui cesta de natal
                  </label>

                  <Input
                    type="text"
                    value={formData.brinquedo_1}
                    onChange={(e) => handleChange("brinquedo_1", e.target.value)}
                    placeholder="Brinquedo 1"
                  />
                  <Input
                    type="text"
                    value={formData.brinquedo_2}
                    onChange={(e) => handleChange("brinquedo_2", e.target.value)}
                    placeholder="Brinquedo 2"
                  />
                  <Input
                    type="text"
                    value={formData.brinquedo_3}
                    onChange={(e) => handleChange("brinquedo_3", e.target.value)}
                    placeholder="Brinquedo 3"
                  />
                  <Input
                    type="text"
                    value={formData.brinquedo_4}
                    onChange={(e) => handleChange("brinquedo_4", e.target.value)}
                    placeholder="Brinquedo 4"
                  />
                  <Input
                    type="text"
                    value={formData.brinquedo_5}
                    onChange={(e) => handleChange("brinquedo_5", e.target.value)}
                    placeholder="Brinquedo 5"
                  />

                  <label style={{ marginBottom: 12 }}>
                    <input
                      type="checkbox"
                      checked={formData.limpaData}
                      onChange={(e) => handleChange("limpaData", e.target.checked)}
                      style={{ marginRight: 6 }}
                    />
                    Limpar data do envio de email
                  </label>
                </FormContent>
                <br />
                <Button type="submit">Atualizar</Button>
              </Form>
              <CloseModalButton
                onClick={() => {
                  setShowModal(!showModal);
                }}
              />
            </ModalContent>
          </animated.div>
        </Background>
      ) : null}
    </>
  );
}
